import { render } from "./BasicComp.vue?vue&type=template&id=63251542&scoped=true"
import script from "./BasicComp.vue?vue&type=script&lang=js"
export * from "./BasicComp.vue?vue&type=script&lang=js"

import "./BasicComp.vue?vue&type=style&index=0&id=63251542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63251542"]])

export default __exports__